export function isTicketTypeDeleted(ticket: { deleted?: boolean | null | string }): boolean {
  return ticket?.deleted === true || ticket?.deleted === 'true'
}

export function filterActiveTicketTypes<T extends { deleted?: boolean | null | string }>(
  items: T[] | null | undefined
): T[] {
  if (!items) {
    return []
  }
  return items.filter(t => !isTicketTypeDeleted(t))
}
